import * as S from "../styles";

export function ComponentExplicativo() {
  return (
    <>
      <S.ContentFilterThree>
        <S.Legend>
          <S.LegendColor backgroundColor={"#e90006"}></S.LegendColor>
          <label>Atrasado</label>

          <S.LegendColor backgroundColor={"#770b60"}></S.LegendColor>
          <label>Ordem de produção</label>

          <S.LegendColor backgroundColor={"#b62aff"}></S.LegendColor>
          <label>Saida para compra</label>

          <S.LegendColor backgroundColor={"#22d4c9"}></S.LegendColor>
          <label>Recebimento</label>

          <S.LegendColor backgroundColor={"#c0b900"}></S.LegendColor>
          <label>Inicio Desembalagem</label>

          <S.LegendColor backgroundColor={"#1a97bf"}></S.LegendColor>
          <label>Finalização Desembalagem</label>
        </S.Legend>
      </S.ContentFilterThree>

      <S.ContentFilterThree>
        <S.Legend>
          <S.LegendColor backgroundColor={"#D0D0D0"}></S.LegendColor>
          <label>Bloqueado</label>

          <S.LegendColor backgroundColor={"#e78d00"}></S.LegendColor>
          <label>Personalização</label>

          <S.LegendColor backgroundColor={"#00a653"}></S.LegendColor>
          <label>Finalização / Nosso Carro</label>

          <S.LegendColor backgroundColor={"#795548"}></S.LegendColor>
          <label>Finalização / Cliente Retira</label>

          <S.LegendColor backgroundColor={"black"}></S.LegendColor>
          <label>Finalização / Transportadora retira</label>

          <S.LegendColor backgroundColor={"#e9006f"}></S.LegendColor>
          <label>Finalização / Motoboy</label>
        </S.Legend>
      </S.ContentFilterThree>
    </>
  );
}
